import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injector,
  input,
  OnInit,
  output,
  signal,
  Signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { finalize, tap } from 'rxjs';
import { Account } from '../../../core/models/account.model';
import { AccountsQuery } from '../../../core/queries/accounts.query';

@UntilDestroy()
@Component({
  selector: 'lib-account-layout',
  templateUrl: './account-layout.component.html',
  styleUrls: ['./account-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AccountLayoutComponent implements OnInit {
  accountList: Signal<Account[]>;
  view: AccountView;
  accountToEdit: Signal<Account>;

  accountId = input<string>();
  worksiteId = input<string>();
  isModal = input<boolean>(false);
  // eslint-disable-next-line @angular-eslint/no-output-native
  cancel = output<void>();
  accountSubmitted = output<Account>();
  accountToAttestera = output<Account>();

  isLoading = signal(true);
  AccountView = AccountView;
  _accountId: string;
  _worksiteId: string;
  injector = inject(Injector);

  sendMessage(account: Account) {
    this.accountSubmitted.emit(account);
  }
  setListView() {
    if (this.isModal) {
      this.cancel.emit();
    } else {
      this.view = AccountView.List;
    }
  }

  constructor(
    private route: ActivatedRoute,
    private accountsQuery: AccountsQuery,
  ) {}

  ngOnInit() {
    this._accountId =
      this.route.snapshot.queryParams.accountId ?? this.accountId();
    this._worksiteId =
      this.route.snapshot.queryParams.worksiteId ?? this.worksiteId();

    if (!this._accountId && !this._worksiteId) {
      this.isLoading.set(false);
      this.view = AccountView.Form;
    }
    if (this._accountId) {
      this.view = AccountView.Form;
      this.accountToEdit = toSignal(
        this.accountsQuery.getAccount(this._accountId).pipe(
          finalize(() => {
            this.isLoading.set(false);
          }),
        ),
        { injector: this.injector },
      );
    } else {
      this.accountList = toSignal(
        this.accountsQuery.getAccountList(this._worksiteId).pipe(
          tap((accountList) => {
            this.view =
              accountList.length > 0 ? AccountView.List : AccountView.Form;
          }),
          finalize(() => {
            this.isLoading.set(false);
          }),
        ),
        { injector: this.injector },
      );
    }
  }
}

export enum AccountView {
  List,
  Form,
}
